import { Component, OnInit } from '@angular/core';
import { GenerateTokenService } from 'integrationpingid-lib';

@Component({
  selector: 'app-login-sdk',
  standalone: true,
  imports: [],
  templateUrl: './login-sdk.component.html',
  styleUrl: './login-sdk.component.scss'
})
export class LoginSdkComponent implements OnInit {
  code: string;
  state: string;
  constructor(
    private generateTokenService: GenerateTokenService,
  ) { }

  ngOnInit(): void {
    const url = window.location.search;
    this.getParameters(url);
  }

  getParameters(search: string): void {
    const parameters = new URLSearchParams(search);

    if (parameters.has('code') && parameters.has('state')) {
      this.code = parameters.get('code');
      this.state = parameters.get('state');
      localStorage.setItem('codeAuthorization', this.code);
      localStorage.setItem('stateAuthorization', this.state);
      this.generateTokenService.retrieveToken();
    }

  }
}
